import React, { useEffect, useRef, useState } from 'react'
import { useLoaderData, useLocation, useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Formik, useFormik, Field, Form } from 'formik'
import CustomError from '../../../../utils/customError'
import Swal from 'sweetalert2'
import { SWAL_SETTINGS, INPUT_MAX_25, PHONE_NO_LENGTH, LOADER_TIMEOUT_TIME, DOCTOR_SPECIALIZATION, SUGAR_TYPE, ROLE } from '../../../../utils/Constants'
import { handleServerValidations, DT, globalLoader, getDateWithTime, removeSpecialCharacter, capitalizeFirstLetter, formateDate, handleOffcanvasScroll, formateDateWithMonth, extractTime, calculateAgeFromDob } from '../../../../utils/commonfunction'
import { DatePicker, Drawer } from 'rsuite'
import { createPrescription, detail, editHealth, getAppointments, getPrescription, medicalHistoryDocument, sendOTP, uploadMedicalHistoryDocument, verifyOTP } from "../../services/patient.services";
import { useValidationSchemas } from '../../validator/validation'
import { Reference } from 'yup'
import OtpInput from "react-otp-input";
import { getAllMedicine } from '../../../admin/services/medicine.services'

export default function ConsultationHistoryView() {
    const { t } = useTranslation()
    const params = useParams();
    const [refreshList, setRefreshList] = useState(false);
    const [openWithHeaderVerifyOTP, setOpenWithHeaderVerifyOTP] = useState(false);
    const { otpValidationSchema } = useValidationSchemas();
    const [medicalHistoryData, setMedicalHistoryData] = useState([]);
    const [resendDisabled, setResendDisabled] = useState(false);
    const [counter, setCounter] = useState(0);
    const navigate = useNavigate();
    const [consultationHistoryDetails, setConsultationHistoryDetails] = useState({});
    const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
    const [openWithHeader, setOpenWithHeader] = useState(false);
    const [medicineData, setMedicineData] = useState([]);
    const [prescriptionData, setPrescriptionData] = useState({});
    const location = useLocation();
    const [showModal, setShowModal] = useState(false);
    const { addMedicalHistoryValidationSchema } = useValidationSchemas();
    const [documentData, setDocumentData] = useState([]);

    // console.log("data",location.state.tab)


    useEffect(() => {
        getAppointments({ appointment_id: params?.id })
            .then((response) => {
                setConsultationHistoryDetails(response?.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [refreshList]);

    const handleResend = async () => {
        setResendDisabled(true);
        setCounter(30);
        let formData = new FormData();
        // formData.append("otp", otp);
        sendOTP(formData)
            .then((response) => {
                if (response.success) {
                    Swal.fire({
                        icon: "success",
                        text: response.message,
                        ...SWAL_SETTINGS,
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        text: response.message,
                        ...SWAL_SETTINGS,
                    });
                }
            })
            .catch((error) => {
                globalLoader(false);
                console.log("error: ", error);
            });
    };

    const handleSendOTP = async (item) => {
        let formData = new FormData();
        formData.append("o_id", consultationHistoryDetails?.patient_id);
        sendOTP(formData)
            .then((response) => {
                if (response.success) {
                    //no otp authentication required
                    if(!response.data.otp_authentication_required){
                        const patientHistoryList = response?.data?.patient_history_list;
                        navigate(`/doctor/consultation/medical-history/view`, { state: { medical_data: patientHistoryList, info: consultationHistoryDetails, tab_data: location?.state?.tab } })
                    }else{
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        setOpenWithHeaderVerifyOTP(true);
                    }
                } else {
                    Swal.fire({
                        icon: "error",
                        text: response.message,
                        ...SWAL_SETTINGS,
                    });
                }
            })
            .catch((error) => {
                console.log("error: ", error);
            });
    };


    const handleSubmit = async (values) => {
        const otpValue = values.otp;
        try {
            await otpValidationSchema.validate(values, { abortEarly: false });
            let formData = new FormData();
            formData.append("patient_id", consultationHistoryDetails?.patient_id);
            formData.append("otp", otpValue);
            verifyOTP(formData)
                .then((response) => {
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        setMedicalHistoryData(response?.data);
                        setOpenWithHeaderVerifyOTP(false);
                        navigate(`/doctor/consultation/medical-history/view`, { state: { medical_data: response?.data, info: consultationHistoryDetails, tab_data: location?.state?.tab } })
                        // const modalElement = document.getElementById("view-medical-history");
                        // if (modalElement) {
                        //     modalElement.classList.add("show");
                        // }
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                    }
                })
                .catch((error) => {
                    console.log("error: ", error);
                });
        } catch (error) {
            console.log(error)
        }
    };

    useEffect(() => {
        getAllMedicine(ROLE.DOCTOR)
            .then((data) => {
                if (data && data.data) {
                    setMedicineData(data?.data || []);
                }
            })
            .catch((error) => {
                console.log("error ====> ", error);
            });
    }, [])

    const getPrescriptionDetail = (id) => {
        getPrescription({ appointment_id: id })
            .then((response) => {
                setPrescriptionData(response?.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const handleClose = () => {
        setShowModal(false);
    };

    const addMedicalHistory = useFormik({
        initialValues: {
            medical_history_document: [],
            medical_history_note: '',
        },
        validationSchema: addMedicalHistoryValidationSchema,
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
            const formData = new FormData();
            formData.append("patient_id", consultationHistoryDetails?.patient_id);
            formData.append("appointment_id", params?.id);
            // formData.append("medical_history_document", values.medical_history_document);
            console.log("values",values.medical_history_document)
            values.medical_history_document.forEach((file) => {
                formData.append("medical_history_document", file);
            });
            formData.append("medical_history_note", values.medical_history_note);

            uploadMedicalHistoryDocument(formData)
                .then((response) => {
                    setShowModal(false);
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        resetForm();
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                    }
                })
                .catch((error) => {
                    console.error("Error ===>", error);
                });
        },
    })

    const viewPrescription = (row) => {
        navigate(`/doctor/consultation/prescription/view/${row}`);
    }


    return (
        <main id="main-content" className="mt-4">
            <div className='ms-3 me-3'>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card p-4 mb-4 card-info">
                            <h3>Personal Info</h3>
                            <p className="mb-1">#{consultationHistoryDetails?.patient_register_id}</p>
                            <h4 className="mb-1">{capitalizeFirstLetter(consultationHistoryDetails?.patient_name)}</h4>
                            <div className='mb-3 d-flex gap-2 align-items-center'>
                                <p className='m-0'>{capitalizeFirstLetter(consultationHistoryDetails?.gender || "Male")}</p>
                                <p className='m-0'>I</p>
                                <p className='m-0'>{consultationHistoryDetails?.patient_phone_no}</p>
                            </div>
                            <div className='table-div-info'>
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>Height</p></div>
                                    <div className='table-div-info-item'>
                                        <p className='m-0'>
                                            {consultationHistoryDetails?.health_matrix?.height
                                                ? `${consultationHistoryDetails.health_matrix.height} cm`
                                                : "-"}
                                        </p>
                                    </div>
                                </div>
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>Weight</p></div>
                                    <div className='table-div-info-item'>
                                        <p className='m-0'>
                                            {consultationHistoryDetails?.health_matrix?.weight
                                                ? `${consultationHistoryDetails.health_matrix.weight} Kg`
                                                : "-"}
                                        </p>
                                    </div>
                                </div>
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>Age</p></div>
                                    <div className='table-div-info-item'>
                                        <p className='m-0'>
                                            {consultationHistoryDetails?.patient_dob
                                                ? `${calculateAgeFromDob(consultationHistoryDetails.patient_dob)} Years`
                                                : "-"}
                                        </p>
                                    </div>
                                </div>
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>Blood Pressure</p></div>
                                    <div className='table-div-info-item'>
                                        <p className='m-0'>
                                            {consultationHistoryDetails?.health_matrix?.blood_pressure
                                                ? `${consultationHistoryDetails.health_matrix.blood_pressure} mm/hg`
                                                : "-"}
                                        </p>
                                    </div>
                                </div>
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>Pulse Rate</p></div>
                                    <div className='table-div-info-item'>
                                        <p className='m-0'>
                                            {consultationHistoryDetails?.health_matrix?.pulse_rate
                                                ? `${consultationHistoryDetails.health_matrix.pulse_rate} BPM`
                                                : "-"}
                                        </p>
                                    </div>
                                </div>
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>Fasting Level Sugar</p></div>
                                    <div className='table-div-info-item'>
                                        <p className='m-0'>
                                            {consultationHistoryDetails?.health_matrix?.fasting_sugar_level
                                                ? `${consultationHistoryDetails.health_matrix.fasting_sugar_level} mg/dl`
                                                : "-"}
                                        </p>
                                    </div>
                                </div>
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>Postprandial Sugar</p></div>
                                    <div className='table-div-info-item'>
                                        <p className='m-0'>
                                            {consultationHistoryDetails?.health_matrix?.postprandial_sugar
                                                ? `${consultationHistoryDetails.health_matrix.postprandial_sugar} mg/dl`
                                                : "-"}
                                        </p>
                                    </div>
                                </div>
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>HbA1c Sugar</p></div>
                                    <div className='table-div-info-item'>
                                        <p className='m-0'>
                                            {consultationHistoryDetails?.health_matrix?.hba1c_sugar
                                                ? `${consultationHistoryDetails.health_matrix.hba1c_sugar} %`
                                                : "-"}
                                        </p>
                                    </div>
                                </div>
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>SpO2 Level</p></div>
                                    <div className='table-div-info-item'>
                                        <p className='m-0'>
                                            {consultationHistoryDetails?.health_matrix?.spo2
                                                ? `${consultationHistoryDetails.health_matrix.spo2} %`
                                                : "-"}
                                        </p>
                                    </div>                                    
                                </div>
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>Temperature</p></div>
                                    <div className='table-div-info-item'>
                                        <p className='m-0'>
                                            {consultationHistoryDetails?.health_matrix?.temperature
                                                ? `${consultationHistoryDetails.health_matrix.temperature} °F`
                                                : "-"}
                                        </p>
                                    </div>                                    
                                </div>
                                {/* <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>Sugar Type</p></div>
                                    <div className='table-div-info-item'>
                                        <p className='m-0'>
                                            {consultationHistoryDetails?.health_matrix?.sugar_type ?
                                                capitalizeFirstLetter(removeSpecialCharacter(consultationHistoryDetails?.health_matrix?.sugar_type)) : "-"}
                                        </p>
                                    </div>
                                </div> */}
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>Sleep Pattern</p></div>
                                    <div className='table-div-info-item'>
                                        <p className='m-0'>
                                            {consultationHistoryDetails?.health_matrix?.sleep_pattern ?
                                                capitalizeFirstLetter(removeSpecialCharacter(consultationHistoryDetails?.health_matrix?.sleep_pattern)) : "-"}
                                        </p>
                                    </div>
                                </div>
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>Digestion</p></div>
                                    <div className='table-div-info-item'>
                                        <p className='m-0'>{capitalizeFirstLetter(consultationHistoryDetails?.health_matrix?.digestion) || "-"}</p>
                                    </div>
                                </div>
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>Urine Frequency</p></div>
                                    <div className='table-div-info-item'>
                                        <p className='m-0'>{consultationHistoryDetails?.health_matrix?.urine_frequency || "-"}</p>
                                    </div>
                                </div>
                                <div className='card-info-action'>
                                    <button className="btn btn-primary mt-2"
                                        // onClick={() => navigate(`/doctor/consultation-history/1`)}>
                                        onClick={() => navigate(-1)}>
                                        Back
                                    </button>
                                </div>
                            </div>

                        </div>
                        <div className="card p-4 mb-4 card-info">
                            <h3>Consultation Details</h3>
                            <p className="mb-1">#{consultationHistoryDetails?.appointment_register_id}</p>
                            <h4 className="mb-1">{capitalizeFirstLetter(consultationHistoryDetails?.doctor_name)}</h4>
                            <div className='mb-3 d-flex gap-2 align-items-center'>
                                <p className='m-0'>{formateDate(consultationHistoryDetails?.appointment_date)}</p>
                            </div>
                        </div>
                        <div className="card p-4 mb-4 card-info">
                            <h3>Prescription</h3>
                            <p>"Click on the relevant button to manage the patient’s prescription."</p>
                            <div className='card-info-action'>
                                {consultationHistoryDetails?.prescription?.length === 0 && location?.state?.tab !== 'past' ?
                                    <button className="btn btn-primary mt-2"
                                        onClick={() => {
                                            navigate(`/doctor/consultation/prescription/add`, { state: { data: consultationHistoryDetails } });
                                        }}
                                    >Create
                                    </button> : null}
                                {consultationHistoryDetails?.prescription?.length !== 0 ?
                                    <button className="btn btn-secondary mt-2 ms-2"
                                        onClick={() => {
                                            // getPrescriptionDetail(consultationHistoryDetails?._id);
                                            viewPrescription(consultationHistoryDetails?._id)
                                        }}
                                    >View
                                    </button>
                                    : null}
                                {consultationHistoryDetails?.prescription?.length !== 0 && location?.state?.tab !== 'past' ?
                                    <button className="btn btn-success mt-2 ms-2"
                                        onClick={() => {
                                            navigate(`/doctor/consultation/prescription/edit/${consultationHistoryDetails?._id}`, { state: { data: consultationHistoryDetails } });
                                        }}
                                    >Edit
                                    </button>
                                    : null}
                            </div>
                        </div>
                        <div className="card p-4 card-info">
                            <h3>Medical History</h3>
                            <p>"Click on the 'View' button to access patient's medical history after verifying the OTP."</p>
                            <div className='card-info-action'>
                                {location?.state?.tab !== 'past' ?
                                    <button
                                        className="btn btn-primary mt-2 me-2"
                                        onClick={() => { setShowModal(true) }}
                                    >Upload Past Medical History
                                    </button> : null}
                                <button className="btn btn-primary mt-2"
                                    onClick={() => {
                                        handleSendOTP(consultationHistoryDetails);
                                    }}
                                >View
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Drawer open={openWithHeaderVerifyOTP} onClose={() => setOpenWithHeaderVerifyOTP(false)}>
                <Drawer.Header closeButton={false}>
                    <div className="d-flex justify-content-between w-100 align-items-center">
                        <h3 className="mb-0">View Medical History</h3>
                        <button
                            className="btn-icon"
                            onClick={() => setOpenWithHeaderVerifyOTP(false)}
                        >
                            <i className="ri-close-fill"></i>
                        </button>
                    </div>
                </Drawer.Header>

                <Drawer.Body>
                    <div className="">
                        <h3 className="mt-2 ms-0">{t("center.otp_verification.heading")}</h3>
                    </div>
                    <Formik
                        initialValues={{ otp: "" }}
                        validationSchema={otpValidationSchema}
                        onSubmit={handleSubmit}
                    >
                        {({ setFieldValue, errors, touched }) => (
                            <Form>
                                {/* OTP Input Section */}
                                <div className="d-flex w-100 justify-content-between">
                                    <div className="col-md-3 number-otp-section">
                                        <Field name="otp">
                                            {({ field }) => (
                                                <OtpInput
                                                    {...field}
                                                    inputType="number"
                                                    onChange={(value) => setFieldValue("otp", value)}
                                                    numInputs={4}
                                                    separator={<span>-</span>}
                                                    renderInput={(props, index) => (
                                                        <input
                                                            {...props}
                                                            key={index}
                                                            className="form-control"
                                                            style={{
                                                                width: "6rem",
                                                                marginRight: "10px",
                                                                textAlign: "center",
                                                                fontWeight: 600,
                                                            }}
                                                            maxLength="1"
                                                            autoFocus={index === 0}
                                                            placeholder="-"
                                                        />
                                                    )}
                                                />
                                            )}
                                        </Field>
                                        {errors.otp && touched.otp && (
                                            <div className="text-danger mt-1" style={{ display: "ruby-text" }}>{errors.otp}</div>
                                        )}
                                    </div>
                                </div>
                                <div className="button-form mt-3">
                                    <button type="submit" className="btn btn-primary w-100">
                                        Continue
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                    <div className="login-cta-bottom mt-3">
                        <p style={{ textAlign: "center" }}>
                            {t("center.otp_verification.otp_not_receive")}{" "}
                            <a
                                className={`${resendDisabled ? " disabled" : ""}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (!resendDisabled) {
                                        handleResend();
                                    }
                                }}
                                href="/"
                            >
                                {t("center.otp_verification.btn_resend")}
                            </a>
                            {resendDisabled && <span className="text-secondary ms-2">({counter})</span>}
                        </p>
                    </div>
                </Drawer.Body>
            </Drawer>
            <div className={`modal fade ${showModal ? 'show' : ''}`} id="modalUploadDocument" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" style={{ display: showModal ? 'block' : 'none' }}>
                <div className="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable" style={{ maxWidth: '500px', marginTop: '-8%' }}>
                    <div className="modal-content">
                        {/* Modal Header */}
                        <div className="modal-header">
                            <h3 className="modal-title" id="exampleModalLabel">Upload Past Medical History</h3>
                            <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
                        </div>

                        {/* Modal Body */}
                        <div className="modal-body">
                            <div className="cancel-modal-info gap-4">
                                <form onSubmit={addMedicalHistory.handleSubmit}>
                                    <div className="row">
                                        <div className="col-md-12 mb-4">
                                            <label htmlFor="medical_history_document" className="form-label">
                                                {t("Document")}:
                                            </label>
                                            <input
                                                className="form-control imgInput"
                                                id="medical_history_document"
                                                name="medical_history_document"
                                                // accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.rtf,.odt,.ppt,.pptx"
                                                type="file"
                                                // onChange={(event) => {
                                                //     addMedicalHistory.setFieldValue(
                                                //         "medical_history_document",
                                                //         event.target.files[0] || ""
                                                //     );
                                                // }}
                                                multiple
                                                onChange={(event) => {
                                                    const files = event.target.files;
                                                    const fileArray = files ? Array.from(files) : [];
                                                    addMedicalHistory.setFieldValue("medical_history_document", fileArray);
                                                    console.log("Selected files:", fileArray);
                                                  }}
                                            />
                                            <span className="text-danger d-flex text-left">
                                                <CustomError name="medical_history_document" form={addMedicalHistory} />
                                            </span>
                                        </div>

                                        <div className="col-md-12 mb-4">
                                            <label className="form-label">
                                                History Note:
                                            </label>
                                            <textarea
                                                type="text"
                                                className="form-control"
                                                name="medical_history_note"
                                                value={addMedicalHistory?.values?.medical_history_note}
                                                onChange={addMedicalHistory.handleChange}
                                                onBlur={addMedicalHistory.handleBlur}
                                            />
                                            <span className="text-danger d-flex text-left">
                                                <CustomError name="medical_history_note" form={addMedicalHistory} />
                                            </span>
                                        </div>
                                    </div>
                                    {/* Submit Button */}
                                    <div className="button-form">
                                        <button type="submit" className={`btn btn-success w-100`}>
                                            Upload
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Modal Backdrop */}
            <div className={`modal-backdrop fade ${showModal ? 'show' : ''}`} style={{ display: showModal ? 'block' : 'none' }}></div>
        </main>
    )
}
